export const colorClasses = [
    { bgClass: 'bg-docpgrPurple', color: 'var(--docpgr-purple)'},
    { bgClass: 'bg-frenchRose', color: 'var(--french-rose' },
    { bgClass: 'bg-finn', color: 'var(--finn)' },
    { bgClass: 'bg-cerulean', color: 'var(--cerulean)' },
    { bgClass: 'bg-saffron', color: 'var(--saffron)' },
    { bgClass: 'bg-imperialRed', color: 'var(--imperial-red)' },
];